<nmo-simple-header></nmo-simple-header>

<div class="main-wrap">
  @if (videoGroups) {
    <nmo-video-container-v3 
      [defaultVideo]="defaultVideo" 
      [groups]="videoGroups" 
      (groupChange)="trackVideoContainerSlideChange($event)"
    ></nmo-video-container-v3>
  }
</div>

<nmo-simple-footer></nmo-simple-footer>
